<template>
  <div class="ppv-stats-row">
    <PpvStatCard
      :icon="icons.mdiAccountGroup"
      :label="$t('ppv.stats.total')"
      :value="stats.total"
      @click="trackMetricClick('total')"
    />
    <PpvStatCard
      :icon="icons.mdiAlertOutline"
      :label="$t('ppv.stats.high_priority')"
      :value="stats.highPriority"
      @click="trackMetricClick('high_priority')"
    />
    <PpvStatCard
      :icon="icons.mdiClockOutline"
      :label="$t('ppv.stats.avg_time')"
      :value="stats.avgTime"
      :unit="$t('ppv.stats.minutes')"
      @click="trackMetricClick('avg_time')"
    />
    <PpvStatCard
      :icon="icons.mdiChartLine"
      :label="$t('ppv.stats.avg_risk')"
      :value="stats.avgRisk"
      @click="trackMetricClick('avg_risk')"
    >
      <template #header-extra>
        <v-tooltip top nudge-left="110" content-class="ppv-custom-tooltip" max-width="250">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              size="18"
              color="#a0aec0"
              class="ppv-info-icon"
            >
              {{ icons.mdiInformationOutline }}
            </v-icon>
          </template>
          <span>{{ $t('ppv.stats.avg_risk_tooltip') }}</span>
        </v-tooltip>
      </template>
    </PpvStatCard>
  </div>
</template>

<script>
import icons from '@/mixins/icons'
import { EVENTS, PVI_PANEL_NAME } from '@/plugins/analytics/events'
import PpvStatCard from './shared/PpvStatCard.vue'

export default {
  name: 'PpvStatsHeader',
  components: {
    PpvStatCard
  },
  mixins: [icons],
  props: {
    visits: {
      type: Array,
      required: true
    }
  },
  computed: {
    stats() {
      const visits = this.visits
      const count = visits.length

      if (!count) {
        return {
          total: 0,
          highPriority: 0,
          avgTime: 0,
          avgRisk: 0
        }
      }

      let highPriority = 0
      let totalDuration = 0
      let totalConditions = 0

      visits.forEach(v => {
        const triage = (v.triage || '').toLowerCase()
        if (triage === 'immediate' || triage === 'urgent') {
          highPriority++
        }

        totalDuration += v.duration || 0
        totalConditions += v.conditions?.length || 0
      })

      return {
        total: count,
        highPriority,
        avgTime: Math.round((totalDuration / 60) / count),
        avgRisk: Math.round(totalConditions / count)
      }
    }
  },
  methods: {
    trackMetricClick(metric) {
      this.$track(EVENTS.PV_METRIC_CLICKED, {
        metric,
        panel_name: PVI_PANEL_NAME,
      })
    },
  },
}
</script>

<style>
.ppv-custom-tooltip {
  background-color: #1a2340 !important;
  color: #fff !important;
  font-size: 13px !important;
  padding: 10px 14px !important;
  border-radius: 6px !important;
  opacity: 1 !important;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
}

.ppv-custom-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  right: 15px; /* Adjust according to the icon's position */
  border-width: 6px;
  border-style: solid;
  border-color: #1a2340 transparent transparent transparent;
  transform: translateX(50%);
}
</style>

<style scoped>
.ppv-stats-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}
@media (max-width: 1100px) {
  .ppv-stats-row {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 600px) {
  .ppv-stats-row {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
}
.ppv-info-icon {
  flex-shrink: 0;
}
</style>
